// extracted by mini-css-extract-plugin
export default {"modal-base":"modal-base_modal-base__-PbIb","modal-base--open":"modal-base_modal-base--open__awJ5d","modal-base__overlay":"modal-base_modal-base__overlay__Q8cgc"};